import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import forms from 'modules/surveys/store/collections/forms'
import type Form from 'modules/surveys/store/models/Form'

export function useSurveyFormV1(formId: string): {
  loading: boolean
  form: Form | null | undefined
} {
  const [form, setForm] = React.useState(forms.get(formId))

  const { loading } = useAsyncData(async () => {
    if (form) return

    setForm(undefined)
  }, [formId])

  return {
    loading,
    form,
  }
}
